import {Component, OnInit} from '@angular/core';
import {Blank} from '../../../models/blank.model';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute} from '@angular/router';
import {Response} from '@angular/http';

@Component({
  selector: 'app-blanks-standard',
  templateUrl: './blanks-standard.component.html',
  styleUrls: ['./blanks-standard.component.css']
})
export class BlanksStandardComponent implements OnInit {
  blankList: any[] = [];
  isLoaded = false;
  hasNoFiles = false;
  errorInit = false;
  errorMessage: string;

  constructor(private userService: UserService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.userService.getBlanks(this.route.snapshot.params['id']).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.blankList = response.body;
          this.isLoaded = true;
        }
        if (response.status === 204) {
          this.hasNoFiles = true;
          this.errorMessage = 'Standard has no any blanks';
          this.isLoaded = true;
        }
      },
      (error) => {
        this.errorInit = true;
        this.errorMessage = 'Failed getting blanks';
      },
      () => {
        this.isLoaded = true;
      }
    );
  }

  getBlankFile(blankID) {
    this.isLoaded = false;
    this.userService.getFile(blankID).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/blanks-standard/blanks-standard.component.ts